import React from 'react';

import TextInputField from 'components/layout/forms/TextInputField';
import {
  formatServerDate,
  formatServerDateTime,
} from 'services/dates/serverTime';

const UpdatedField = ({
  className,
  compact,
  label,
  updated,
  updatedUser,
}: {
  className?: string;
  // Only the date in the field, the time and the name of the user in the tooltip
  compact?: boolean;
  label: string;
  updated: null | string;
  updatedUser: any;
}): JSX.Element => {
  // In the time of the browser: the server sends UTC
  const date = updated === null ? '' : formatServerDateTime(updated);

  const getValue = () => {
    if (updated === null || updatedUser === null || updatedUser === undefined) {
      return date;
    }

    const { firstName, lastName } = updatedUser;
    return `${date}, ${firstName} ${lastName}`;
  };

  // The whole time and name as a tooltip when the field is narrow
  return (
    <TextInputField
      className={className}
      disabled
      label={label}
      required
      title={getValue()}
      value={
        compact && updated !== null ? formatServerDate(updated) : getValue()
      }
    />
  );
};

export default UpdatedField;
